import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule, FltFilterModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';
import { MaintenanceModule } from 'app/main/maintenance/maintenance.module';
//import { FakeDbService } from 'app/fake-db/fake-db.service';
import { Security } from 'app/model/security.model';
import { AppService } from 'app/app.service';

import { OktaAuthGuard, OktaAuthModule, OktaCallbackComponent, OktaAuthService, OKTA_CONFIG } from '@okta/okta-angular';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import { UsuarioAutenticadoGuard } from 'app/guard/usuario-autenticado.guard';
import { UsuarioNaoAutenticadoGuard } from 'app/guard/usuario-nao-autenticado.guard';
import { FltGuardAuth } from 'app/flt-guard/flt-guard.auth';

const security = new Security();


//const config: SocketIoConfig = { url: 'http://flt-iot.appspot.com', options: {} };

const oktaConfig = Object.assign({
    onAuthRequired: ({ oktaAuth, router }) => {
        router.navigate(['/login']);
    }
}, {
    url: security.OktaURL,
    issuer: security.OktaIssuer,
    redirectUri: security.OktaRedirectURL,
    clientId: security.OktaClientId,
    /*
        url: "https://dev-830132.okta.com",
       issuer: "https://dev-830132.okta.com/oauth2/default"
       redirectUri: window.location.origin + "/login/callback",
       clientId: "0oa3diagf5V9aCxKf4x7",
       pkce: true
    */
    //scope: 'viriato.ignacio@felitron.com.br'
    scope: 'viriato@flt-lab.com'
});




const appRoutes: Routes = [
    {
        path: 'register',
        loadChildren: './main/register/register.module#RegisterModule',
        //canActivate: [OktaAuthGuard]
        canActivate: [FltGuardAuth]
    },
    {
        path: 'dashboard',
        loadChildren: './main/dashboard/analytics.module#AnalyticsDashboardModule',
        canActivate: [OktaAuthGuard]
    },
    {
        path: 'module',
        loadChildren: './main/module/module.module#ModuleModule',
        
        //canActivate: [OktaAuthGuard]
    },
    {
        path: 'config',
        loadChildren: './main/config/config.module#ConfigModule',
        canActivate: [OktaAuthGuard]

    },
    {
        path: 'settings',
        loadChildren: './main/settings/settings.module#SettingsModule',
        canActivate: [FltGuardAuth]
    },
    {
        path: 'login',
        loadChildren: './main/login/login.module#LoginModule'
    },
    {
        path: 'fltlogin',
        loadChildren: './main/fltlogin/fltlogin.module#FLTLoginModule'
    },
    {
        path: 'control',
        loadChildren: './main/control/control.module#ControlModule'
    },
    {
        path: 'opportunity',
        loadChildren: './main/opportunity/opportunity.module#OpportunityModule',
        canActivate: [UsuarioAutenticadoGuard]
        //, canActivate: [OktaAuthGuard]
    },
    {
        path: 'opportunity/:id',
        loadChildren: './main/opportunity/opportunity.module#OpportunityModule'//,
        //canActivate: [UsuarioAutenticadoGuard]
        //, canActivate: [OktaAuthGuard]
    },
    {
        path: 'opportunitylist',
        loadChildren: './main/opportunity-list/opportunity-list.module#OpportunityListModule'//,
        //canActivate: [UsuarioAutenticadoGuard]
        //, canActivate: [OktaAuthGuard]
    },
    {
        path: 'computer/:computer',
        loadChildren: './main/computer/computer.module#ComputerModule'
    },
    {
        path: 'subscribe',
        loadChildren: './main/subscribe/subscribe.module#SubscribeModule'
    },
    {
        path: 'geolocation',
        loadChildren: './main/geolocation/geolocation.module#GeolocationModule'
    },
    {
        path: 'implicit/callback',
        component: OktaCallbackComponent
        // redirectTo: 'opportunity'
    },
    
    /*
    ,
    {
        path: 'implicit/fltcallback',
        redirectTo: 'opportunity'
    },
    */
    {
        path: '**',
        redirectTo: 'register/infra'
        //redirectTo: './main/dashboard/analytics'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),
        TranslateModule.forRoot(),
        // Material moment date module
        MatMomentDateModule,
        // Material
        MatButtonModule,
        MatIconModule,
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        // FLT Modules
        FltFilterModule,
        // App modules
        LayoutModule,
        SampleModule,
        MaintenanceModule,
        OktaAuthModule
        //,
        //SocketIoModule.forRoot(config)
        //      FakeDbService
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        {
            provide: OKTA_CONFIG,
            useValue: oktaConfig
        },
        OktaAuthService,
        OktaAuthGuard,
        AppService

    ]
})
export class AppModule {
}
